import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';

/**
 * LzCrudModelListGroupActionIcon class
 */
export default class LzCrudModelListGroupActionIcon {

    constructor(model) {
        if (!model) {
            model = {};
        }

        this.title = model.title ? model.title : '';
        this.icon = model.icon ? model.icon : '';
        this.color = model.color ? model.color : '';
        this.confirmation = model.confirmation ? model.confirmation : '';
        this.checksNotRequiredToShow = !!model.checksNotRequiredToShow;
    }

    static parseData(data, crud) {
        const out = {};

        if (!crud || crud.noGroupActions) {
            return out;
        }

        if (!data) {
            data = {};
        }

        const keys = Object.keys(data);
        for (const key of keys) {
            out[key] = new LzCrudModelListGroupActionIcon(data[key]);
        }

        // Now add based on crud settings
        if (crud.showStatusGroupAction && !out.status_active) {
            out.status_active = new LzCrudModelListGroupActionIcon({ title: 'Activate Selected', icon: <CheckIcon />, color: 'success', confirmation: 'Are you sure you want to activate all selected records?' });
        }
        if (crud.showStatusGroupAction && !out.status_inactive) {
            out.status_inactive = new LzCrudModelListGroupActionIcon({ title: 'De-Activate Selected', icon: <CloseIcon />, color: 'warning', confirmation: 'Are you sure you want to de-activate all selected records?' });
        }
        if (crud.showDeleteGroupAction && !out.delete) {
            out.delete = new LzCrudModelListGroupActionIcon({ title: 'Delete Selected', icon: <DeleteIcon />, color: 'danger', confirmation: 'Are you sure you want to delete all selected records?' });
        }

        return out;
    }

}
